import Lottie from 'lottie-react';

import avatarIconSearch from '../jsons/avatar-icon-search.json';

const AvatarIconSearch = props => {
  return <Lottie loop={false} animationData={avatarIconSearch} {...props} />;
};

export default AvatarIconSearch;
